var e = /* @__PURE__ */ ((s) => (s.AccessToken = "access_token", s.ChainType = "chain_type", s.FakeRefreshToken = "fake_refresh_token", s.Provider = "provider", s.RefreshToken = "refresh_token", s.UserId = "user_id", s.SsoState = "sso_state", s.SsoLoginType = "sso_login_type", s))(e || {});
export {
  e as LocalStorageKey
};
//# sourceMappingURL=storage.js.map
